// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"6cd2fdbf","447":"645721d6","641":"acf37545","720":"b033ed56","740":"b17b9ac5"}[chunkId] + ".chunk.js";
};